import request from '@/utils/request'
import Vue from 'vue'

export function getMyvideoList(data) {
    return request({
        method: 'POST',
        url: Vue.prototype.baseURL + '/services/fs-message/selectListByPage',
        data
    })
}
